// HeaderNoAuth.js - Simple header for non-authenticated users
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../buttons/Button';
import './HeaderNoAuth.css';

function HeaderNoAuth() {
  const navigate = useNavigate();

  return (
    <nav className="header-no-auth">
      <div className="header-no-auth-container">
        <div className="header-no-auth-left">
          <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Logo" className="header-no-auth-logo" />
          <h1 className="header-no-auth-title">voxia</h1>
        </div>
        <div className="header-no-auth-actions">
          <Button
            variant="secondary"
            onClick={() => navigate('/auth')}
          >
            Se connecter
          </Button>
          <Button
            variant="primary"
            onClick={() => navigate('/auth')}
          >
            S'inscrire
          </Button>
        </div>
      </div>
    </nav>
  );
}

export default HeaderNoAuth;
